import {
  PAYROLL_SALARY_LOADING,
  GET_PAYROLL_SALARY,
  GET_PAYROLL_SALARY_SUCCESS,
  GET_PAYROLL_SALARY_FAIL,
  ADD_PAYROLL_SALARY_SUCCESS,
  ADD_PAYROLL_SALARY_FAIL,
  DELETE_PAYROLL_SALARY_SUCCESS,
  DELETE_PAYROLL_SALARY_FAIL,
  UPDATE_PAYROLL_SALARY_SUCCESS,
  UPDATE_PAYROLL_SALARY_FAIL,
  PAYROLL_SALARY_RESET
} from "./actionType";

const INIT_STATE = {
  payrollSalarys: [],
  error: {},
};

const PayrollSalary = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLL_SALARY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYROLL_SALARY:
          return {
            ...state,
            payrollSalarys: action.payload.data,
            isPayrollSalaryCreated: false,
            isPayrollSalarySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PAYROLL_SALARY_FAIL:
      switch (action.payload.actionType) {
        case GET_PAYROLL_SALARY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPayrollSalaryCreated: false,
            isPayrollSalarySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PAYROLL_SALARY: {
      return {
        ...state,
        isPayrollSalaryCreated: false,
        loading: true,
      };
    }

    case PAYROLL_SALARY_LOADING: {
      return {
        ...state,
        isPayrollSalaryCreated: false,
        loading: true,
      };
    }

    case ADD_PAYROLL_SALARY_SUCCESS:
      return {
        ...state,
        isPayrollSalaryCreated: true,
        loading: false,
        payrollSalarys: [action.payload.data, ...state.payrollSalarys],
      };

    case ADD_PAYROLL_SALARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PAYROLL_SALARY_SUCCESS:
      return {
        ...state,
        loading: false,
        isPayrollSalaryCreated: true,
        payrollSalarys: state.payrollSalarys.filter(
          payrollSalary => payrollSalary.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PAYROLL_SALARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PAYROLL_SALARY_SUCCESS:
      return {
        ...state,
        loading: false,
        isPayrollSalaryCreated: true,
        payrollSalarys: state.payrollSalarys.map(payrollSalary =>
          payrollSalary.id.toString() === action.payload.data.id.toString() ? { ...payrollSalary, ...action.payload.data } : payrollSalary
        ),
      };

    case UPDATE_PAYROLL_SALARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PAYROLL_SALARY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PayrollSalary;